// extracted by mini-css-extract-plugin
var _1 = "Qz5BU";
export { _1 as "removeLastMargin" }
